<template>
  <div
    :data-cy="`agent-${agent.id}`"
    class="flex items-center space-x-4 rounded-sm p-2"
    :class="{ 'bg-label/10': isActive }"
    @click="emit('agent:click')"
    @mouseover="emit('agent:hover')"
  >
    <icon-base
      :icon="IconAINav"
      class="text-label"
      width="20"
      height="20"
      view-box="0 0 30 30"
    />
    <div class="flex flex-col space-y-1">
      <span class="text-headline capitalize">{{ agent.name }}</span>
      <span class="text-label">{{ agent.description }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
import IconAINav from "@/components/icons/IconAINav.vue";
import IconBase from "@/components/ui/IconBase.vue";

import type { AiAgentBase } from "@/models/aiAgents";

const { agent, isActive = false } = defineProps<{
  agent: AiAgentBase;
  isActive?: boolean;
}>();

const emit = defineEmits<{
  "agent:hover": [];
  "agent:click": [];
}>();
</script>
